/**
 * Subscription free shipping for Upcart drawer.
 * Upcart renders inside Shadow DOM — we pierce shadow roots to find the panel
 * and inject the banner inside the open cart shadow tree.
 */
(function () {
  var DISCOUNT_CODE = 'FREESHIP';
  var BANNER_ID = 'kn-subscription-free-shipping';
  var STYLE_ID = 'kn-subscription-free-shipping-style';
  var UPCART_EVENTS = {
    opened: 'aftersell-upcart:public-events:cart-opened',
    closed: 'aftersell-upcart:public-events:cart-closed',
    updated: 'aftersell-upcart:public-events:cart-updated',
    loaded: 'aftersell-upcart:public-events:cart-loaded',
    added: 'aftersell-upcart:public-events:added-to-cart',
    removed: 'aftersell-upcart:public-events:item-removed',
  };

  var state = {
    unlocked: false,
    cartOpen: false,
    syncing: false,
    syncQueued: false,
    injecting: false,
    lastDiscount: null,
    suppressCartHook: false,
  };

  var positionTimer = null;
  var pollTimer = null;
  var watchTimer = null;
  var observedRoots = [];

  /**
   * Strict check: only real Shopify selling plans count.
   * Do NOT use title/properties heuristics — Skio/Upcart often leave leftover
   * labels after converting subscription → one-time, which caused false unlocks.
   */
  function cartHasSubscription(cart) {
    if (!cart || !Array.isArray(cart.items) || !cart.items.length) return false;
    return cart.items.some(function (item) {
      if (!item) return false;
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        return true;
      }
      if (item.selling_plan_allocation) return true;
      // Some cart payloads expose plan id directly
      if (item.selling_plan && item.selling_plan !== '' && item.selling_plan !== '0') {
        return true;
      }
      return false;
    });
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  /* ---------- Shadow DOM helpers ---------- */

  function collectShadowHosts(root, out) {
    out = out || [];
    if (!root) return out;
    var nodes = root.querySelectorAll ? root.querySelectorAll('*') : [];
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.shadowRoot) {
        out.push(node);
        collectShadowHosts(node.shadowRoot, out);
      }
    }
    // also check root itself if element
    if (root.shadowRoot && out.indexOf(root) === -1) {
      out.push(root);
      collectShadowHosts(root.shadowRoot, out);
    }
    return out;
  }

  function queryDeepAll(selector, root) {
    root = root || document;
    var results = [];
    try {
      results = Array.prototype.slice.call(root.querySelectorAll(selector));
    } catch (e) {}

    var hosts = collectShadowHosts(root);
    for (var i = 0; i < hosts.length; i++) {
      var sr = hosts[i].shadowRoot;
      if (!sr) continue;
      try {
        var found = sr.querySelectorAll(selector);
        for (var j = 0; j < found.length; j++) results.push(found[j]);
      } catch (e2) {}
      // recurse already done via collectShadowHosts
    }
    return results;
  }

  function queryDeepOne(selector, root) {
    var all = queryDeepAll(selector, root);
    return all.length ? all[0] : null;
  }

  function getShadowRootOf(el) {
    if (!el) return null;
    if (el.shadowRoot) return el.shadowRoot;
    // walk up composed path parents
    var node = el;
    while (node) {
      var root = node.getRootNode && node.getRootNode();
      if (root && root.nodeType === 11) return root; // DocumentFragment / ShadowRoot
      node = node.parentNode;
    }
    return null;
  }

  function bannerCssText() {
    return [
      '#' + BANNER_ID + '{',
      '  display:block !important;',
      '  visibility:visible !important;',
      '  opacity:1 !important;',
      '  width:100%;',
      '  box-sizing:border-box;',
      '  padding:8px 16px 12px;',
      '  position:relative;',
      '  z-index:50;',
      '  flex-shrink:0;',
      '}',
      '#' + BANNER_ID + '[hidden]{display:none !important;}',
      '#' + BANNER_ID + ' .kn-fs__inner{',
      '  display:flex;',
      '  align-items:center;',
      '  gap:8px;',
      '  padding:10px 12px;',
      '  border-radius:8px;',
      '  background:#e8f5ee;',
      '  color:#0e1d30;',
      '  border:1px solid #b7e0c7;',
      '  box-shadow:0 2px 10px rgba(0,0,0,.08);',
      '}',
      '#' + BANNER_ID + ' .kn-fs__text{margin:0;font-size:13px;line-height:1.35;font-family:inherit;}',
      '#' + BANNER_ID + ' .kn-fs__text strong{font-weight:700;}',
      '#' + BANNER_ID + ' .kn-fs__icon{display:inline-flex;flex-shrink:0;color:#1b7a45;}',
      /* Only hide Upcart rewards MODULE — never the whole cart */
      '.upcart-public-rewards.kn-fs-reward-hidden,',
      '.upcart-internal-rewards.kn-fs-reward-hidden,',
      '.upcart-public-rewards__message.kn-fs-reward-hidden,',
      '.upcart-public-rewards__bar.kn-fs-reward-hidden{',
      '  display:none !important;',
      '}',
    ].join('');
  }

  function restoreWronglyHidden(root) {
    if (!root || !root.querySelectorAll) return;
    var nodes = root.querySelectorAll('[data-kn-fs-hidden="true"]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].style.removeProperty('display');
      nodes[i].removeAttribute('data-kn-fs-hidden');
      nodes[i].classList.remove('kn-fs-reward-hidden');
    }
  }

  function updateUpcartRewardsUI(unlocked) {
    var up = document.getElementById('upCart');
    var roots = [];
    if (up && up.shadowRoot) roots.push(up.shadowRoot);
    if (up) roots.push(up);
    roots.push(document);

    var hosts = collectShadowHosts(up || document.body);
    for (var i = 0; i < hosts.length; i++) {
      if (hosts[i].shadowRoot) roots.push(hosts[i].shadowRoot);
    }

    // Always clear previous aggressive hides first (fixes drawer disappearing)
    for (var c = 0; c < roots.length; c++) {
      restoreWronglyHidden(roots[c]);
      if (roots[c].classList) {
        roots[c].classList.remove('kn-fs-hide-upcart-rewards');
      }
      var popupClear =
        roots[c].getElementById && roots[c].getElementById('UpcartPopup');
      if (popupClear && popupClear.classList) {
        popupClear.classList.remove('kn-fs-hide-upcart-rewards');
      }
    }

    if (!unlocked) return;

    for (var r = 0; r < roots.length; r++) {
      var root = roots[r];
      if (!root || !root.querySelectorAll) continue;

      // SAFE: only exact Upcart rewards module selectors
      var rewardNodes = [];
      try {
        rewardNodes = Array.prototype.slice.call(
          root.querySelectorAll(
            '.upcart-public-rewards, .upcart-internal-rewards, .upcart-public-rewards__message, .upcart-public-rewards__bar, .upcart-public-rewards__skeleton, .upcart-public-rewards__skeleton-bar, .upcart-public-rewards__skeleton-message'
          )
        );
      } catch (e) {}

      for (var n = 0; n < rewardNodes.length; n++) {
        rewardNodes[n].classList.add('kn-fs-reward-hidden');
        rewardNodes[n].setAttribute('data-kn-fs-hidden', 'true');
        rewardNodes[n].style.setProperty('display', 'none', 'important');
      }
    }
  }

  function ensureStylesIn(targetRoot) {
    targetRoot = targetRoot || document;
    var head = targetRoot.head || targetRoot;
    var existing = head.querySelector ? head.querySelector('#' + STYLE_ID) : null;
    if (existing) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = bannerCssText();
    if (head.appendChild) head.appendChild(style);
  }

  function createBannerEl() {
    var el = document.createElement('div');
    el.id = BANNER_ID;
    el.setAttribute('data-subscription-free-shipping', 'true');
    el.innerHTML =
      '<div class="kn-fs__inner">' +
      '<span class="kn-fs__icon" aria-hidden="true">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">' +
      '<path d="M3 7h11v10H3V7Zm11 3h4l3 3v4h-7V10Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
      '<circle cx="7" cy="18.5" r="1.5" fill="currentColor"/>' +
      '<circle cx="17" cy="18.5" r="1.5" fill="currentColor"/>' +
      '</svg>' +
      '</span>' +
      '<p class="kn-fs__text">You\'ve unlocked <strong>free shipping</strong> with your subscription!</p>' +
      '</div>';
    return el;
  }

  function removeAllBanners() {
    // light DOM
    var light = document.getElementById(BANNER_ID);
    if (light) light.remove();

    // shadow trees under #upCart and body hosts
    var hosts = collectShadowHosts(document);
    for (var i = 0; i < hosts.length; i++) {
      var sr = hosts[i].shadowRoot;
      if (!sr) continue;
      var b = sr.getElementById ? sr.getElementById(BANNER_ID) : sr.querySelector('#' + BANNER_ID);
      if (b) b.remove();
    }
  }

  function findInsertPoint() {
    var root = document.getElementById('upCart') || document.body;

    var header =
      queryDeepOne('.upcart-public-header', root) ||
      queryDeepOne('[class*="Header"]', root) ||
      queryDeepOne('header', root);

    if (header && header.parentNode) {
      return { parent: header.parentNode, before: header.nextSibling, shadow: getShadowRootOf(header) };
    }

    var rewards =
      queryDeepOne('.upcart-public-rewards', root) ||
      queryDeepOne('[class*="Rewards"]', root);
    if (rewards && rewards.parentNode) {
      return { parent: rewards.parentNode, before: rewards, shadow: getShadowRootOf(rewards) };
    }

    var items =
      queryDeepOne('.upcart-public-cart-items', root) ||
      queryDeepOne('.upcart-internal-cart-items', root) ||
      queryDeepOne('[class*="CartItems"]', root);
    if (items && items.parentNode) {
      return { parent: items.parentNode, before: items, shadow: getShadowRootOf(items) };
    }

    var card =
      queryDeepOne('[class*="CartPreview__card"]', root) ||
      queryDeepOne('.upcart-internal-cart-preview__container', root) ||
      queryDeepOne('[class*="CartPreview"]', root);

    if (card) {
      return { parent: card, before: card.firstChild, shadow: getShadowRootOf(card) };
    }

    // Prefer inside #UpcartPopup after header
    var up = document.getElementById('upCart');
    if (up && up.shadowRoot) {
      var popup = up.shadowRoot.getElementById('UpcartPopup');
      if (popup) {
        var popupHeader =
          popup.querySelector('.upcart-public-header') ||
          popup.querySelector('[class*="Header"]') ||
          popup.querySelector('header');
        if (popupHeader && popupHeader.parentNode) {
          return {
            parent: popupHeader.parentNode,
            before: popupHeader.nextSibling,
            shadow: up.shadowRoot,
          };
        }
        return { parent: popup, before: popup.firstChild, shadow: up.shadowRoot };
      }
      return { parent: up.shadowRoot, before: up.shadowRoot.firstChild, shadow: up.shadowRoot };
    }

    // Any open shadow host near upcart
    var hosts = collectShadowHosts(up || document.body);
    for (var i = 0; i < hosts.length; i++) {
      var sr = hosts[i].shadowRoot;
      if (!sr) continue;
      var rect = hosts[i].getBoundingClientRect();
      if (rect.width < 200 || rect.height < 150) continue;
      return { parent: sr, before: sr.firstChild, shadow: sr };
    }

    return null;
  }

  function findDrawerPanel() {
    var root = document.getElementById('upCart') || document;
    var selectors = [
      '[class*="CartPreview__card"]',
      '[class*="CartPreview__position-fixed"]',
      '.upcart-internal-cart-preview__container',
      '.upcart-public-header',
      '.upcart-cart',
      '[class*="CartPreview"]',
    ];

    var best = null;
    var bestScore = 0;

    for (var s = 0; s < selectors.length; s++) {
      var list = queryDeepAll(selectors[s], root);
      for (var i = 0; i < list.length; i++) {
        var el = list[i];
        var rect = el.getBoundingClientRect();
        if (rect.width < 200 || rect.height < 120) continue;
        if (rect.bottom <= 0 || rect.top >= window.innerHeight) continue;
        var score = rect.width * rect.height;
        if (rect.left > window.innerWidth * 0.35) score *= 1.4;
        if (score > bestScore) {
          bestScore = score;
          best = el;
        }
      }
    }

    return best;
  }

  function isDrawerVisiblyOpen() {
    var panel = findDrawerPanel();
    if (!panel) {
      // shadow host itself may be the panel
      var up = document.getElementById('upCart');
      if (!up) return false;
      var hosts = collectShadowHosts(up);
      for (var i = 0; i < hosts.length; i++) {
        var rect = hosts[i].getBoundingClientRect();
        if (rect.width >= 240 && rect.height >= 200 && rect.bottom > 0 && rect.top < window.innerHeight) {
          return true;
        }
      }
      return false;
    }
    var r = panel.getBoundingClientRect();
    return r.width >= 200 && r.height >= 120 && r.bottom > 0 && r.top < window.innerHeight;
  }

  function injectBannerIntoShadow() {
    if (state.injecting) return;
    state.injecting = true;

    try {
      if (!state.unlocked || (!state.cartOpen && !isDrawerVisiblyOpen())) {
        removeAllBanners();
        updateUpcartRewardsUI(false);
        state.injecting = false;
        return;
      }

      updateUpcartRewardsUI(true);

      var point = findInsertPoint();
      if (!point || !point.parent) {
        // Fallback: fixed body banner on the right
        ensureStylesIn(document);
        var bodyBanner = document.getElementById(BANNER_ID);
        if (!bodyBanner) {
          bodyBanner = createBannerEl();
          document.body.appendChild(bodyBanner);
        }
        bodyBanner.removeAttribute('hidden');
        bodyBanner.style.position = 'fixed';
        bodyBanner.style.top = '72px';
        bodyBanner.style.right = '0';
        bodyBanner.style.left = 'auto';
        bodyBanner.style.width = 'min(420px, 100vw)';
        bodyBanner.style.zIndex = '2147483000';
        bodyBanner.classList.add('is-visible');
        state.injecting = false;
        return;
      }

      var shadow = point.shadow || getShadowRootOf(point.parent) || null;
      if (shadow) ensureStylesIn(shadow);
      ensureStylesIn(document);

      // If already correctly placed, keep it
      var existingInParent = null;
      if (point.parent.querySelector) {
        existingInParent = point.parent.querySelector('#' + BANNER_ID);
      }
      if (existingInParent) {
        existingInParent.removeAttribute('hidden');
        existingInParent.style.position = '';
        existingInParent.style.top = '';
        existingInParent.style.right = '';
        existingInParent.style.width = '';
        updateUpcartRewardsUI(true);
        state.injecting = false;
        return;
      }

      removeAllBanners();
      var banner = createBannerEl();
      point.parent.insertBefore(banner, point.before || null);
      observeRoot(point.parent.getRootNode ? point.parent.getRootNode() : point.parent);
      updateUpcartRewardsUI(true);
    } catch (e) {
      console.log('[KN FreeShip] inject failed', e);
    }

    state.injecting = false;
  }

  function positionBanner() {
    injectBannerIntoShadow();
  }

  function schedulePosition() {
    clearTimeout(positionTimer);
    positionTimer = setTimeout(positionBanner, 30);
    setTimeout(positionBanner, 200);
    setTimeout(positionBanner, 500);
    setTimeout(positionBanner, 1000);
  }

  function observeRoot(root) {
    if (!root || observedRoots.indexOf(root) !== -1) return;
    // Only observe Element / ShadowRoot / Document
    if (!root.querySelectorAll && root.nodeType !== 11 && root.nodeType !== 9) return;
    observedRoots.push(root);

    try {
      var observer = new MutationObserver(function () {
        if (state.injecting) return;
        if (!state.unlocked) return;
        if (!state.cartOpen && !isDrawerVisiblyOpen()) return;

        var hasBanner = false;
        try {
          hasBanner = !!(root.getElementById && root.getElementById(BANNER_ID));
          if (!hasBanner && root.querySelector) hasBanner = !!root.querySelector('#' + BANNER_ID);
        } catch (e) {}

        if (!hasBanner) injectBannerIntoShadow();
      });
      observer.observe(root, { childList: true, subtree: true });
    } catch (e2) {}
  }

  function observeUpcartShadows() {
    var up = document.getElementById('upCart');
    if (up) {
      observeRoot(up);
      if (up.shadowRoot) observeRoot(up.shadowRoot);
    }
    var hosts = collectShadowHosts(up || document.body);
    for (var i = 0; i < hosts.length; i++) {
      if (hosts[i].shadowRoot) observeRoot(hosts[i].shadowRoot);
    }
  }

  function applyDiscount(unlocked) {
    if (state.lastDiscount === unlocked) return;
    state.lastDiscount = unlocked;

    if (unlocked) {
      fetch('/discount/' + encodeURIComponent(DISCOUNT_CODE), { credentials: 'same-origin' }).catch(function () {});
    } else {
      document.cookie = 'discount_code=; Path=/; Max-Age=0';
      document.cookie = 'discount_code=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT';
      // Clear discount on cart without re-triggering our fetch hook
      state.suppressCartHook = true;
      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: '' }),
      })
        .catch(function () {})
        .finally(function () {
          setTimeout(function () {
            state.suppressCartHook = false;
          }, 50);
        });
    }
  }

  function syncFromCart(cart, opts) {
    opts = opts || {};
    // Always prefer a fresh /cart.js after selling-plan switches — Upcart event
    // payloads can be stale right when OTP is selected.
    var forceFresh = opts.forceFresh !== false;

    if (state.syncing) {
      state.syncQueued = true;
      return Promise.resolve();
    }
    state.syncing = true;

    var promise = !forceFresh && cart && cart.items ? Promise.resolve(cart) : getCart();

    return promise
      .then(function (cartData) {
        var unlocked = cartHasSubscription(cartData);
        var changed = unlocked !== state.unlocked;
        state.unlocked = unlocked;
        applyDiscount(state.unlocked);

        if (!state.unlocked) {
          removeAllBanners();
          updateUpcartRewardsUI(false);
        } else if (changed || state.cartOpen || isDrawerVisiblyOpen()) {
          positionBanner();
          updateUpcartRewardsUI(true);
        }
      })
      .catch(function (err) {
        console.log('[KN FreeShip] sync failed', err);
      })
      .finally(function () {
        state.syncing = false;
        if (state.syncQueued) {
          state.syncQueued = false;
          // Small delay so Shopify finishes writing selling_plan:null
          setTimeout(function () {
            syncFromCart(null, { forceFresh: true });
          }, 150);
        }
      });
  }

  /** Schedule fresh /cart.js reads at one or more delays (OTP switch needs retries) */
  function queueFreshSync(delayMs) {
    var delays = Array.isArray(delayMs) ? delayMs : [typeof delayMs === 'number' ? delayMs : 250];
    delays.forEach(function (ms) {
      setTimeout(function () {
        if (state.suppressCartHook) return;
        syncFromCart(null, { forceFresh: true }).then(function () {
          if (state.cartOpen || isDrawerVisiblyOpen()) {
            if (state.unlocked) schedulePosition();
            else {
              removeAllBanners();
              updateUpcartRewardsUI(false);
            }
          }
        });
      }, ms);
    });
  }

  function startPolling() {
    stopPolling();
    var ticks = 0;
    pollTimer = setInterval(function () {
      ticks += 1;
      var visible = isDrawerVisiblyOpen();
      if (visible && !state.cartOpen) {
        state.cartOpen = true;
        queueFreshSync(0);
      }
      if (state.cartOpen || visible) {
        observeUpcartShadows();
        // Re-check cart every ~1.5s while drawer open so OTP switch is caught
        if (ticks % 3 === 0) {
          syncFromCart(null, { forceFresh: true }).then(function () {
            if (state.unlocked) positionBanner();
            else {
              removeAllBanners();
              updateUpcartRewardsUI(false);
            }
          });
        } else if (state.unlocked) {
          positionBanner();
        } else {
          removeAllBanners();
          updateUpcartRewardsUI(false);
        }
      }
    }, 500);
  }

  function stopPolling() {
    if (pollTimer) {
      clearInterval(pollTimer);
      pollTimer = null;
    }
  }

  function startWatcher() {
    if (watchTimer) return;
    watchTimer = setInterval(function () {
      observeUpcartShadows();
      var visible = isDrawerVisiblyOpen();
      if (visible) {
        if (!state.cartOpen) {
          state.cartOpen = true;
          queueFreshSync(0);
          startPolling();
        } else if (state.unlocked) {
          positionBanner();
        }
      }
    }, 700);
  }

  function onOpened() {
    state.cartOpen = true;
    observeUpcartShadows();
    syncFromCart(null, { forceFresh: true }).then(function () {
      schedulePosition();
      startPolling();
    });
  }

  function onClosed() {
    state.cartOpen = false;
    stopPolling();
    removeAllBanners();
  }

  function onCartChanged() {
    // Never trust Upcart detail for selling_plan — always re-fetch /cart.js
    // (OTP switch often fires before Shopify cart has finished updating)
    queueFreshSync([100, 400, 900]);
  }

  function bindUpcartEvents() {
    window.addEventListener(UPCART_EVENTS.opened, onOpened);
    window.addEventListener(UPCART_EVENTS.closed, onClosed);
    window.addEventListener(UPCART_EVENTS.updated, function (e) {
      onCartChanged(e && e.detail);
    });
    window.addEventListener(UPCART_EVENTS.loaded, function (e) {
      onCartChanged(e && e.detail);
    });
    window.addEventListener(UPCART_EVENTS.added, function (e) {
      state.cartOpen = true;
      onCartChanged(e && e.detail);
      startPolling();
      schedulePosition();
    });
    window.addEventListener(UPCART_EVENTS.removed, function (e) {
      onCartChanged(e && e.detail);
    });
    window.addEventListener('resize', function () {
      if (state.cartOpen) positionBanner();
    });
  }

  function bindUpcartSubscribeApi() {
    function safeSub(name, fn) {
      if (typeof window[name] !== 'function') return;
      try {
        window[name](fn);
      } catch (e) {}
    }

    safeSub('upcartSubscribeCartOpened', onOpened);
    safeSub('upcartSubscribeCartClosed', onClosed);
    safeSub('upcartSubscribeCartUpdated', onCartChanged);
    safeSub('upcartSubscribeCartLoaded', onCartChanged);
    safeSub('upcartSubscribeAddedToCart', function (detail) {
      state.cartOpen = true;
      onCartChanged(detail);
      startPolling();
      schedulePosition();
    });
    safeSub('upcartSubscribeItemRemoved', onCartChanged);
  }

  if (typeof window.fetch === 'function') {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var input = arguments[0];
      var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
      var method = (arguments[1] && arguments[1].method) || (input && input.method) || 'GET';
      var looksLikeCartWrite =
        /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i.test(url) ||
        (/selling_plan/i.test(url) && String(method).toUpperCase() !== 'GET');

      // Detect selling_plan changes in request body (OTP ↔ Subscribe)
      var body = arguments[1] && arguments[1].body;
      var bodyHasPlanChange = false;
      try {
        if (typeof body === 'string' && /selling_plan/i.test(body)) bodyHasPlanChange = true;
      } catch (e) {}

      return originalFetch.apply(this, arguments).then(function (response) {
        if (state.suppressCartHook) return response;
        if (looksLikeCartWrite || bodyHasPlanChange) {
          queueFreshSync([150, 450, 1000]);
        }
        return response;
      });
    };
  }

  // Upcart / Skio may use XHR for cart changes
  if (typeof XMLHttpRequest !== 'undefined') {
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._knFsUrl = url;
      this._knFsMethod = method;
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      var url = String(xhr._knFsUrl || '');
      if (/\/cart\/(add|change|update|clear)/i.test(url) || /selling_plan/i.test(url)) {
        xhr.addEventListener('loadend', function () {
          if (state.suppressCartHook) return;
          queueFreshSync([150, 500]);
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  function emergencyRestoreDrawer() {
    // Undo previous overly-broad hide that could wipe the whole Upcart UI
    restoreWronglyHidden(document);
    var up = document.getElementById('upCart');
    if (up) {
      up.classList.remove('kn-fs-hide-upcart-rewards');
      restoreWronglyHidden(up);
      if (up.shadowRoot) restoreWronglyHidden(up.shadowRoot);
    }
    collectShadowHosts(document.body).forEach(function (host) {
      if (host.classList) host.classList.remove('kn-fs-hide-upcart-rewards');
      if (host.shadowRoot) restoreWronglyHidden(host.shadowRoot);
    });
  }

  function boot() {
    ensureStylesIn(document);
    emergencyRestoreDrawer();
    bindUpcartEvents();
    bindUpcartSubscribeApi();
    observeUpcartShadows();
    syncFromCart();
    startWatcher();

    var tries = 0;
    var bootTimer = setInterval(function () {
      tries += 1;
      bindUpcartSubscribeApi();
      observeUpcartShadows();
      if (tries >= 30) clearInterval(bootTimer);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.KeyNutrientsFreeShipping = {
    sync: syncFromCart,
    inject: positionBanner,
    position: positionBanner,
    state: state,
    debug: function () {
      return getCart().then(function (cart) {
        var up = document.getElementById('upCart');
        var hosts = collectShadowHosts(up || document.body).map(function (h) {
          var r = h.getBoundingClientRect();
          return {
            tag: h.tagName,
            id: h.id,
            className: h.className,
            hasShadow: !!h.shadowRoot,
            w: Math.round(r.width),
            h: Math.round(r.height),
          };
        });
        var bannerInLight = !!document.getElementById(BANNER_ID);
        var bannerInShadow = false;
        collectShadowHosts(document).forEach(function (h) {
          if (h.shadowRoot && h.shadowRoot.querySelector('#' + BANNER_ID)) bannerInShadow = true;
        });
        var info = {
          state: state,
          itemCount: cart.item_count,
          hasSubscription: cartHasSubscription(cart),
          drawerVisible: isDrawerVisiblyOpen(),
          bannerInLight: bannerInLight,
          bannerInShadow: bannerInShadow,
          shadowHosts: hosts,
          items: (cart.items || []).map(function (item) {
            return {
              title: item.product_title,
              selling_plan_allocation: item.selling_plan_allocation || null,
              selling_plan: item.selling_plan || null,
            };
          }),
        };
        console.log('[KN FreeShip debug]', info);
        return info;
      });
    },
  };
})();
